import { Component, EventEmitter, Inject, Input, OnDestroy, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { AlertService } from '../../../shared/services/alert.service';
import { Alert } from '../../../shared/models/alert';
import { CognitoUtil } from '../../../shared/services/cognito.service';
import { OrganizationServices } from '../../../shared/services/organization.services';
import { LocalUserService } from '../../../shared/services/localUser';
import { MatDialog, MatDialogRef } from '@angular/material';
import { AlertFormComponent } from './alertForm/alertForm.component';
import { OpenAlertComponent } from './openAlert/openAlert.component';
import { CaseService } from '../../../shared/services/case.service';
import { Case } from '../../../shared/models/case';

@Component({
  selector: 'alertList',
  templateUrl: './alertList.component.html',
  styleUrls: ['./alertList.component.scss'],
  providers: [
    OrganizationServices,
    AlertService,
    LocalUserService
  ],
})
export class AlertListComponent implements OnInit {
  displayedColumns: string[] = ['subject', 'created_date', 'modifiedDate'];

  @Output() readCountUpdate = new EventEmitter<string>();
  @Output() alertLength = new EventEmitter<number>();
  @Input() userId: string;
  @Input() alertStatus: boolean;

  orgId: string;
  token: string;
  role: string;

  alerts = [];
  dialogRef: any;

  openAlerts = [];
  closedAlerts = [];

  casesArray: Case[];

  constructor(
    public dialog: MatDialog,
    private alertService: AlertService,
    private organizationServices: OrganizationServices,
    private router: Router,
    private cognitoUtil: CognitoUtil,
    private localUser: LocalUserService,
    private caseService: CaseService,

  ) { }

  ngOnInit() {
    if(!this.userId){
      this.userId = this.localUser.getUserId();
    }
    this.orgId = this.localUser.getOrganizationId();
    this.role = this.localUser.getRole();
    this.getAlerts();
  }

  getAlerts() {

    switch (this.role) {

      case 'JUDGE':
      case 'CLERK':
        this.alertService.getAlertsByOrgId(this.orgId)
          .subscribe(result => {

            this.sortAlerts(result);

            this.countNotReads();
          });
        break;

      default:
        this.alertService.getAlertsByUserId(this.orgId, this.userId)
          .subscribe(result => {

            this.sortAlerts(result);

            this.countNotReads();
          });
        break;

    }
    this.caseService.getCasesByUserId(this.orgId, this.userId)
      .subscribe(data => {
        this.casesArray = data;
      }, Error => {
        console.log(Error);
      });

  }

  sortAlerts(result) {

    this.openAlerts = [];
    this.closedAlerts = [];
    this.alerts = result;

    for (let i = 0; i < result.length; i++) {
      result[i] = JSON.parse(result[i]);
      if (!result[i].closed) {
        this.openAlerts.push(result[i]);

      }
      else {
        this.closedAlerts.push(result[i]);
      }
    }

    this.openAlerts.sort(function (a, b) {
      return b.created_date - a.created_date;
    });

    this.alertLength.emit(this.openAlerts.length)

  }

  partOfMessage(message) {

    let messagePart = message.substring(0, 35);

    if (messagePart.length < message.length) {
      messagePart += '...';
    }

    return messagePart;
  }

  modifyDate(value) {

    let alertData = this.getAlert(value);

    if (alertData.modified_date !== null) {
      return alertData.modified_date;
    }
    else {
      return alertData.created_date;
    }

  }

  addAlert() {

    this.dialogRef = this.dialog.open(AlertFormComponent, {
      panelClass: 'alert-form-dialog',
      width:'600px',
      data: {
        action: 'new',
        caseList: this.casesArray
      }
    });

    this.dialogRef.afterClosed()
      .subscribe(response => {
        this.getAlerts();
    });
  }

  getAlert(id) {
    for (let i = 0; i < this.alerts.length; i++) {
      if (this.alerts[i].id === id) {
        return this.alerts[i];
      }
    }
  }

  isRead(value) {

    let alertData = this.getAlert(value);

    switch (this.role) {
      case 'CLERK':
      case 'JUDGE':
        return alertData.organization_viewed;
      default:
        return alertData.sender_viewed;
    }

  }

  countNotReads() {

    let count = 0;

    switch (this.role) {
      case 'CLERK':
      case 'JUDGE':
        for (let i = 0; i < this.openAlerts.length; i++) {
          if (!this.openAlerts[i].organization_viewed) {
            count++;
          }
        }
        break;
      default:
        for (let i = 0; i < this.openAlerts.length; i++) {
          if (!this.openAlerts[i].sender_viewed) {
            count++;
          }
        }
        break;
    }

    this.alertLength.emit(count);
  }

  openAlert(value) {

    let alert = this.getAlert(value);

    this.dialogRef = this.dialog.open(OpenAlertComponent, {
      panelClass: 'alert-form-dialog',
      width:'600px',
      data: {
        alert: alert
      }
    });

    this.dialogRef.afterClosed()
      .subscribe(response => {
        this.getAlerts();
      });

  }

}



// WEBPACK FOOTER //
// ./src/app/main/content/common/alertList/alertList.component.ts